import React from 'react';

export const userRoles = {
    'jda' : 'JurisdictionAdmin',
    'rckms' : 'RCKMSAdmin'
};

let defaultUserContext = {
    role: userRoles.jda,
    jurisdictionId: null,
    sessionToken: null
};

const UserContext = React.createContext(defaultUserContext);

export const UserContextProvider = UserContext.Provider;
export const UserContextConsumer = UserContext.Consumer;

